// Local, device-scoped anonymous voting helpers.
const ANON_KEY = "fv_anon_id";
const VOTED_KEY = "fv_voted";

export function getAnonId() {
  let id = localStorage.getItem(ANON_KEY);
  if (!id || id.length < 8) {
    const rand = (typeof crypto !== "undefined" && crypto.randomUUID)
      ? crypto.randomUUID().replace(/-/g, "")
      : Math.random().toString(36).slice(2) + Date.now().toString(36);
    id = "dev" + rand;
    localStorage.setItem(ANON_KEY, id);
  }
  return id;
}

function readVoted() {
  try { return JSON.parse(localStorage.getItem(VOTED_KEY) || "{}"); } catch { return {}; }
}

export function getVote(topicId) {
  return readVoted()[topicId] || null;
}

export function setVote(topicId, side) {
  const v = readVoted();
  v[topicId] = side;
  localStorage.setItem(VOTED_KEY, JSON.stringify(v));
}
